const user = {
  state: {
    user: false,
    tabsList: [],
    nowTab: "",
  },
  mutations: {
    // 登录
    login(state, user) {
      state.user = user;
      localStorage.setItem("userInfo", user);
    },
    // 退出
    logout(state, user) {
      state.user = "";
      state.tabsList = [];
    },
    // add tab
    addTabs(state, tabItem) {
      if (state.tabsList.length == 0) {
        state.tabsList = [tabItem];
      } else if (
        state.tabsList.filter((l) => l.name == tabItem.name).length == 0
      ) {
        state.tabsList.push(tabItem);
      }
      // state.nowTab = tabItem.name
    },
    // del tab
    delTab(state, name) {
      let index = 0;
      for (let item of state.tabsList) {
        if (item.name == name) {
          break;
        }
        index++;
      }
      state.tabsList.splice(index, 1);
    },
    set_nowTab(state, val) {
      state.nowTab = val;
    },
    delAllTabs(state, val) {
      state.tabsList = val ? [val] : [];
    },
  },
};

export default user;


// WEBPACK FOOTER //
// ./src/store/modules/user.js